<template>
  <fin-dialog
    v-model="dialog"
    :max-width="dialogWidth"
    content-class="fin-confirm-dialog"
    persistent
    @input="(val) => {if (val === false){cancel()}}"
  >
    <template v-if="options.title" #title>
      <fin-lexicon-text auto-solve :text="options.title" v-if="options.titleWithLexikonLink"/>
      <span v-else>{{ options.title }}</span>
    </template>

    <template #actions>
      <div class="text-right d-flex">
        <v-btn v-if="options.cancelBtn"
               class="mb-2" outlined
               style="z-index: 35"
               tile
               :small="$vuetify.breakpoint.xsOnly && options.smallButtonBreakpointXsOnly"
               @click.native.capture.stop="cancel"
        >
          <span>{{ options.cancelBtn }}</span>
        </v-btn>

        <v-btn v-if="options.confirmBtn"
               :disabled="isDisabled"
               class="ml-2 mb-2" dark
               style="z-index: 35"
               tile
               :small="$vuetify.breakpoint.xsOnly && options.smallButtonBreakpointXsOnly"
               @click.native.stop="accept('', $event)"
               @blur.stop.prevent="()=>{/*do nothing*/}"
               @keyup.stop.prevent="()=>{/*do nothing*/}"
               @keydown.stop.prevent="()=>{/*do nothing*/}"
               @mouseenter.stop.prevent="()=>{/*do nothing*/}"
               @mouseleave.stop.prevent="()=>{/*do nothing*/}"
               @mousedown.stop.prevent="()=>{/*do nothing*/}"
               @mouseup.stop.prevent="()=>{/*do nothing*/}"
               @touchstart.stop="accept('', $event)"
               @touchend.stop.prevent="()=>{/*do nothing*/}"
               @touchcancel.stop.prevent="()=>{/*do nothing*/}"
               @touchmove.stop.prevent="()=>{/*do nothing*/}"
        >
          <span>{{ options.confirmBtn }}</span>
        </v-btn>
      </div>
    </template>

    <div class="fin-confirm-dialog-content">
      <v-card-text>

        <p class="fin-confirm-dialog-content__text" v-if="options.text">
          <fin-lexicon-text auto-solve :text="options.text" v-if="options.textWithLexikonLink"/>
          <span v-else>{{ options.text }}</span>
        </p>

        <fin-lexicon-text auto-solve :text="options.freeStyleContent" v-if="options.freeStyleContent"/>

        <v-text-field v-if="options.input"
                      v-model="inputText"
                      autocomplete="off"
                      :label="inputLabel"
                      :placeholder="inputPlaceholder"
                      :single-line="!inputMultiline"
                      background-color="#fff"
                      class="fin-confirm-dialog-content__text-field"
                      outlined/>

        <p v-if="options.textBelow" class="fin-confirm-dialog-content__text-below">
          <fin-lexicon-text auto-solve :text="options.textBelow" v-if="options.textBelowWithLexikonLink"/>
          <span v-else>{{ options.textBelow }}</span>
        </p>
      </v-card-text>
    </div>
  </fin-dialog>
</template>

<script>
import {EventBus} from '@/plugins/fincraft'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'

export default {
  name: 'fin-confirm',
  components: {FinLexiconText},
  data() {
    return {
      dialog: false,
      options: {},
      resolve: null,
      reject: null,
      inputText: null,
      inputLabel: null,
      inputMultiline: false,
      inputPlaceholder: null,
      dialogWidth: 780,
      isDisabled: false,
    }
  },
  methods: {
    confirm(obj) {
      this.options = Object.assign({confirmBtn: 'Ok', cancelBtn: 'Abbrechen'}, obj.options)
      this.resolve = obj.resolve
      this.reject = obj.reject
      this.dialog = true
      this.isDisabled = !!this.options.input
      this.inputText = obj.options.inputText
      this.inputLabel = obj.options.inputLabel
      this.inputMultiline = obj.options.inputMultiline
      this.inputPlaceholder = obj.options.inputPlaceholder
      if (obj.options.dialogWidth !== undefined) {
        this.dialogWidth = obj.options.dialogWidth
      }
    },
    cancel: function () {
      // JS error caused by this line this.reject(), therefore replaced by next line
      this.reject({cancel: true})
      this.dialog = false
      this.inputText = ''
    },
    accept: function (message, event) {
      if (event) {
        event.preventDefault()
      }
      this.resolve({inputText: this.inputText})
      this.dialog = false
    },
  },
  watch: {
    inputText() {
      if (this.dialog) {
        this.isDisabled = !!this.options.input && !this.inputText
      }
    },
  },
  mounted() {
    EventBus.$on('confirm', this.confirm)
  },
  beforeDestroy() {
    EventBus.$off('confirm', this.confirm)
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.fin-confirm-dialog-content__text, .fin-confirm-dialog-content__text-below {
  font-size: 1em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
}

.fin-confirm-dialog-content__text {
  margin-bottom: 18px;
}

.fin-confirm-dialog-content__text-below {
  margin-bottom: 32px;
}

.fin-confirm-dialog-content__text-field {
  margin-bottom: 24px;
}

::v-deep .v-text-field__details {
  display: none !important;
}

::v-deep .v-card__text {
  padding: 0 !important;
}

::v-deep div.paragraph {
  margin-bottom: 16px;
}
</style>
